import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import searchHelper from 'app/helpers/searchHelper';
import { Product } from 'app/shared/model/ProductBase';

interface TableSearchProps {
  onSearch: (data: Product[], searchActive?: boolean) => void;
  dataList: Product[];
  disabled: boolean;
}

const TableSearch: React.FC<TableSearchProps> = ({ onSearch, dataList, disabled }) => {
  const [value, setValue] = React.useState("");

  const handleSearch = (value: string): { data: Product[]; active: boolean } => {
    const trimmed = value.trim();
    return {
      data: trimmed !== ''
        ? searchHelper.searchAllData(dataList, trimmed)
        : dataList,
      active: trimmed !== '',
    };
  };

  React.useEffect(() => {
    const reset = () => {
      setValue("");
      onSearch(dataList, false);
    };

    // Fired by `Header.tsx` after confirming division change.
    window.addEventListener('selectedDivisionChanged', reset);

    return () => {
      window.removeEventListener('selectedDivisionChanged', reset);
    };
  }, [onSearch, dataList]);

  return (
    <Input
      allowClear
      disabled={disabled}
      placeholder="Product Name, Product Code or Product ID"
      prefix={<SearchOutlined />}
      value={value}
      onChange={(e) => {
        const next = e.target.value ?? "";
        setValue(next);
        const { data, active } = handleSearch(next);
        onSearch(data, active);
      }}
    />
  );
};

export default TableSearch;